<p-panel [header]="overrideHeader ?? (side === 'input' ? 'Input(s)' : 'Output(s)')" [class.no-frame]="noFrame">
    @if (_pluginFunction && iosMapping) {
        <div class="property-list">
            @for (currentProp of _properties; track currentProp.name) {
                @let showWarning = !iosMapping[currentProp.name] && currentProp.required;

                <div class="property-block" [class.no-separator]="noSeparator" [class.property-warning]="showWarning">
                    <div>
                        @if (showWarning) {
                            <span class="pi pi-exclamation-triangle"></span>
                        }
                        {{ currentProp.name }}
                        @if (currentProp.required) {
                            <span class="color-danger">*</span>
                        }
                    </div>

                    <div>
                        <input
                            type="text"
                            pInputText
                            disabled
                            [(ngModel)]="_ngModels[currentProp.name].content"
                            pSize="small"
                            [class.complex-value]="_ngModels[currentProp.name].complexValue"
                            [ngModelOptions]="{standalone: true}"
                        />
                        @if (side === 'output') {
                            <p-button
                                size="small"
                                icon="pi pi-eye"
                                [disabled]="!_ngModels[currentProp.name].content"
                                pTooltip="See current value"
                                (onClick)="displayCurrentValue(currentProp)"
                            />
                        }
                        <p-button
                            size="small"
                            icon="pi pi-equals"
                            pTooltip="Bind value"
                            [disabled]="!!currentProp.schema.enum?.length"
                            (onClick)="editReferenceExpression(currentProp)"
                        />
                        @if (side === 'input') {
                            <p-button
                                size="small"
                                icon="pi pi-pencil"
                                pTooltip="Edit user value"
                                (onClick)="editUserValue(currentProp)"
                            />
                        }
                    </div>
                </div>
            }
        </div>

        @if (_properties.length === 0) {
            <p class="gray-text centered-text mt-4 mb-4">No {{ side === 'input' ? 'Inputs' : 'Outputs' }} available</p>
        }
    } @else {
        <p class="gray-text centered-text mt-4 mb-4">No function selected</p>
    }
</p-panel>
